@if (isSizeGuideButtonVisible) {
<section
    class="call-to-action-size-guide"
    [class.with-padding-bottom]="withPaddingBottom"
    [class.without-margin]="!hasMargin">
    <div [ngClass]="buttonAlignClass">
        <h-svg-icon
            [name]="isNewMeasureIconEnabled ? 'measure-yourself-horizontal' : 'measure-yourself'"
            class="svg-style"
            [class.revamp-icon]="isNewMeasureIconEnabled"></h-svg-icon>
        <h-action-button
            [loading]="isLoading"
            (click)="openSizeGuideTray()"
            [attr.aria-expanded]="'false'"
            class="display-inline">
            <div i18n="@@hermes_commerce.size-guide" class="size-guide-label paragraph-small">Size Guide</div>
        </h-action-button>
    </div>
    @if (hasErrorLoadingSizeGuide) {
    <h-message-block [showBackground]="false" [type]="'error'">
        <ng-container i18n="@@hermes-global-translations.something-went-wrong">
            Sorry, something's gone wrong.
        </ng-container>
    </h-message-block>
    }
</section>
}
